import React, { useState, useEffect } from "react";

export default function EosAdmin() {
  const [dbDevices, setDbDevices] = useState([]);
  const [editingId, setEditingId] = useState(null); 

  const [deviceName, setDeviceName] = useState("");
  const [deviceType, setDeviceType] = useState("controller");
  const [imageUrl, setImageUrl] = useState("");
  
  const [ports, setPorts] = useState([]);
  
  const [nodeType, setNodeType] = useState("input"); 
  const [portLabel, setPortLabel] = useState("");
  const [wireRule, setWireRule] = useState("");
  const [wireColor, setWireColor] = useState("#000000"); 
  const [tempCoords, setTempCoords] = useState(null);

  const fetchDevices = () => {
    fetch("/api/data?scope=eos_training&action=list_devices")
      .then(res => res.json())
      .then(data => {
        if (data.ok && data.items) {
          const parsed = data.items.map(d => ({
            ...d,
            terminals: typeof d.terminals === "string" ? JSON.parse(d.terminals) : d.terminals
          }));
          setDbDevices(parsed);
        }
      })
      .catch(err => console.error("Failed to load DB devices:", err));
  };

  useEffect(() => { fetchDevices(); }, []);

  const loadDeviceForEdit = (device) => {
    setEditingId(device.id);
    setDeviceName(device.name);
    setDeviceType(device.device_type);
    setImageUrl(device.image_url);
    setPorts(device.terminals || []);
    setTempCoords(null);
  };

  const resetForm = () => {
    setEditingId(null); setDeviceName(""); setDeviceType("controller");
    setImageUrl(""); setPorts([]); setTempCoords(null);
  };

  const handleImageClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setTempCoords({ x: x.toFixed(2), y: y.toFixed(2) });
  };

  const addPort = () => {
    if (!portLabel || !wireRule || !tempCoords) {
      alert("Hold up! Fill in the Label, the Rule/Code, and click the image.");
      return;
    }

    const newNode = {
      id: `node-${Date.now()}`,
      type: nodeType,       
      label: portLabel,
      rule: wireRule,       
      color: nodeType === "output" ? wireColor : (nodeType === "button" ? "rgba(0,150,255,0.4)" : null),
      position: tempCoords
    };

    setPorts([...ports, newNode]);
    setPortLabel(""); setWireRule(""); setTempCoords(null);
  };

  const removePort = (idToRemove) => { setPorts(ports.filter(p => p.id !== idToRemove)); };

  const handleSaveToDatabase = async () => {
    if (!deviceName || !imageUrl || ports.length === 0) {
      alert("Missing info!"); return;
    }
    const finalDeviceConfig = {
      action: editingId ? "update_device" : "save_device",
      id: editingId, name: deviceName, type: deviceType, image: imageUrl, ports: ports 
    };

    try {
      const res = await fetch("/api/data?scope=eos_training", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(finalDeviceConfig)
      });
      const data = await res.json();
      if (data.ok) {
        alert(editingId ? "✅ Updated!" : "✅ Saved!");
        resetForm(); fetchDevices(); 
      } else { alert("❌ Error: " + data.error); }
    } catch (err) { alert("Server error."); }
  };

  // ---> NEW: SEED MA400 BUS LINE PARTS <---
  const handleSeedMA400Parts = async () => {
    const parts = [
      {
        action: "save_device",
        name: "HDi Master Gateway",
        type: "power",
        image: "https://placehold.co/200x200/333/fff?text=HDi+Gateway",
        ports: [
          { id: "g-a", type: "output", label: "Bus A", rule: "bus-a", color: "#007bff", position: {x: "30", y: "80"} },
          { id: "g-b", type: "output", label: "Bus B", rule: "bus-b", color: "#dc3545", position: {x: "70", y: "80"} }
        ]
      },
      {
        action: "save_device",
        name: "Điện Trở 120-Ohm",
        type: "plugin",
        image: "https://placehold.co/100x40/ffc107/000?text=120+Ohm",
        ports: [
          { id: "r-a", type: "output", label: "Chân A", rule: "bus-a", color: "#333", position: {x: "10", y: "50"} },
          { id: "r-b", type: "output", label: "Chân B", rule: "bus-b", color: "#333", position: {x: "90", y: "50"} }
        ]
      }
    ];

    for (const part of parts) {
      await fetch("/api/data?scope=eos_training", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(part)
      });
    }
    alert("✅ Gateway & Resistor seeded into DB!");
    fetchDevices();
  };

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif", maxWidth: "1400px", margin: "0 auto", display: "flex", gap: "20px" }}>
      <div style={{ width: "250px", backgroundColor: "#f9f9f9", padding: "15px", borderRadius: "8px", border: "1px solid #ccc", height: "calc(100vh - 40px)", overflowY: "auto", boxSizing: "border-box" }}>
        <h3 style={{ marginTop: 0 }}>Library</h3>
        <button onClick={resetForm} style={{ width: "100%", padding: "10px", backgroundColor: "#007bff", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: "bold", marginBottom: "5px" }}>+ Create New</button>
        <button onClick={handleSeedMA400Parts} style={{ width: "100%", padding: "10px", backgroundColor: "#ffc107", color: "black", border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: "bold", marginBottom: "15px" }}>⚡ Seed MA400 Parts</button>
        {dbDevices.map(dev => (
          <div key={dev.id} onClick={() => loadDeviceForEdit(dev)} style={{ padding: "10px", border: "1px solid #ddd", marginBottom: "10px", borderRadius: "4px", backgroundColor: editingId === dev.id ? "#e2e6ea" : "#fff", cursor: "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
            <div style={{ fontWeight: "bold", fontSize: "14px" }}>{dev.name}</div>
            <div style={{ fontSize: "11px", color: "#666", textTransform: "uppercase" }}>{dev.device_type}</div>
          </div>
        ))}
      </div>

      <div style={{ width: "350px", backgroundColor: "#f4f4f4", padding: "20px", borderRadius: "8px", height: "fit-content" }}>
        <h2 style={{ marginTop: 0 }}>{editingId ? "✏️ Edit Device" : "⚙️ Add New Device"}</h2>
        <h3>1. Device Info</h3>
        <div style={{ marginBottom: "10px" }}>
          <label style={{ fontWeight: "bold", fontSize: "14px" }}>Device Name:</label>
          <input type="text" value={deviceName} onChange={e => setDeviceName(e.target.value)} style={{ width: "100%", padding: "8px", marginTop: "5px", border: "1px solid #ccc", borderRadius: "4px" }} />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label style={{ fontWeight: "bold", fontSize: "14px" }}>Device Type:</label>
          <select value={deviceType} onChange={e => setDeviceType(e.target.value)} style={{ width: "100%", padding: "8px", marginTop: "5px", border: "1px solid #ccc", borderRadius: "4px" }}>
            <option value="controller">Bộ điều khiển động cơ</option>
            <option value="motor">Động cơ</option>
            <option value="power">Nguồn điện</option>
            <option value="switch">Công tắc nối dây</option>
            <option value="plugin">Plugin / Mô-đun thu</option>
            <option value="remote">Wireless Remote Control</option>
          </select>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={{ fontWeight: "bold", fontSize: "14px" }}>WordPress Image URL:</label>
          <input type="text" value={imageUrl} onChange={e => setImageUrl(e.target.value)} style={{ width: "100%", padding: "8px", marginTop: "5px", border: "1px solid #ccc", borderRadius: "4px" }} />
        </div>
        <hr style={{ margin: "20px 0", border: "1px solid #ddd" }} />

        <h3>2. Map Nodes</h3>
        <div style={{ border: "1px solid #ccc", padding: "15px", backgroundColor: "#fff", marginBottom: "20px", borderRadius: "4px" }}>
          
          <div style={{ display: "flex", gap: "5px", marginBottom: "15px" }}>
            <button onClick={() => setNodeType("input")} style={{ flex: 1, padding: "8px 4px", fontSize: "12px", backgroundColor: nodeType === "input" ? "#007bff" : "#e9ecef", color: nodeType === "input" ? "white" : "black", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer", fontWeight: nodeType === "input" ? "bold" : "normal" }}>📥 Input</button>
            <button onClick={() => setNodeType("output")} style={{ flex: 1, padding: "8px 4px", fontSize: "12px", backgroundColor: nodeType === "output" ? "#28a745" : "#e9ecef", color: nodeType === "output" ? "white" : "black", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer", fontWeight: nodeType === "output" ? "bold" : "normal" }}>📤 Output</button>
            <button onClick={() => setNodeType("button")} style={{ flex: 1, padding: "8px 4px", fontSize: "12px", backgroundColor: nodeType === "button" ? "#ffc107" : "#e9ecef", color: nodeType === "button" ? "black" : "black", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer", fontWeight: nodeType === "button" ? "bold" : "normal" }}>🔘 Button</button>
          </div>

          <label style={{ fontSize: "13px", color: "#333" }}>{nodeType === "button" ? "Button Label:" : (nodeType === "input" ? "Terminal Label:" : "Wire Name:")}</label>
          <input type="text" value={portLabel} onChange={e => setPortLabel(e.target.value)} placeholder={nodeType === "button" ? "e.g. Set, Ch1 Up..." : ""} style={{ width: "100%", padding: "8px", margin: "5px 0 10px 0", boxSizing: "border-box" }} />
          
          <label style={{ fontSize: "13px", color: "#333" }}>{nodeType === "button" ? "Action Code (set, up-1, down-2, stop):" : (nodeType === "input" ? "Accepts Wire Rule:" : "Wire Identity Rule:")}</label>
          <input type="text" value={wireRule} onChange={e => setWireRule(e.target.value)} placeholder={nodeType === "button" ? "up-1" : ""} style={{ width: "100%", padding: "8px", margin: "5px 0 10px 0", boxSizing: "border-box" }} />

          {nodeType === "output" && (
            <div style={{ marginBottom: "15px" }}>
              <label style={{ fontSize: "13px", color: "#333", display: "block" }}>Wire Color:</label>
              <input type="color" value={wireColor} onChange={e => setWireColor(e.target.value)} style={{ width: "100%", height: "40px", marginTop: "5px", cursor: "pointer" }} />
            </div>
          )}

          <div style={{ padding: "10px", backgroundColor: tempCoords ? "#d4edda" : "#ffeeba", marginBottom: "15px", textAlign: "center", fontSize: "14px", border: "1px solid #ccc", borderRadius: "4px" }}>
            {tempCoords ? `🎯 Locked: X ${tempCoords.x}%, Y ${tempCoords.y}%` : "👉 Click the image to set coordinates"}
          </div>

          <button onClick={addPort} style={{ width: "100%", padding: "10px", backgroundColor: "#333", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: "bold" }}>
            + Add {nodeType === "input" ? "Terminal" : (nodeType === "button" ? "Button" : "Wire")}
          </button>
        </div>
        <button onClick={handleSaveToDatabase} style={{ width: "100%", padding: "15px", backgroundColor: editingId ? "#17a2b8" : "#28a745", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer", fontSize: "16px" }}>{editingId ? "💾 Update Device Data" : "💾 Save New Device"}</button>
      </div>

      <div style={{ flex: 1, border: "2px dashed #ccc", display: "flex", justifyContent: "center", alignItems: "flex-start", backgroundColor: "#fff", position: "relative", minHeight: "600px", padding: "20px", overflow: "auto" }}>
        {!imageUrl ? (
          <div style={{ color: "#999", marginTop: "150px", textAlign: "center" }}><h3>No Image Loaded</h3><p>Paste a WordPress Image URL on the left.</p></div>
        ) : (
          <div style={{ position: "relative", display: "inline-block" }}>
            <img src={imageUrl} alt="Mapping" onClick={handleImageClick} style={{ maxWidth: "100%", border: "1px solid #ddd", cursor: "crosshair", display: "block" }} />
            {ports.map((port, index) => (
              <div key={port.id} onClick={() => removePort(port.id)} title={`Click to remove ${port.label}`}
                style={{ position: "absolute", left: `${port.position.x}%`, top: `${port.position.y}%`, width: "24px", height: "24px", 
                  backgroundColor: port.type === "input" ? "rgba(220, 53, 69, 0.8)" : (port.type === "button" ? "rgba(0,150,255,0.8)" : port.color),
                  border: "2px solid white", transform: "translate(-50%, -50%)", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", color: "white", textShadow: "0px 0px 2px #000", fontSize: "12px", fontWeight: "bold", cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.3)" }}>
                {index + 1}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}